import { render, staticRenderFns } from "./OneVillageOneProductDetail.vue?vue&type=template&id=55419a42&scoped=true&"
import script from "./OneVillageOneProductDetail.vue?vue&type=script&lang=js&"
export * from "./OneVillageOneProductDetail.vue?vue&type=script&lang=js&"
import style0 from "./OneVillageOneProductDetail.vue?vue&type=style&index=0&id=55419a42&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55419a42",
  null
  
)

export default component.exports